"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ventasso": {
    "a73ea4d8": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "skipSearch": false
    }],
    "ca-caiti": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9dd76501": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "skipSearch": false
    }],
    "ca-manari": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0e5d5214": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-sechia": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "463339e2": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "skipSearch": false
    }],
    "rosto": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c340fdbf": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia-delle-fonti": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "adb3b3ed": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "skipSearch": false
    }],
    "tassaro": [{
      "hkey": "0ebcea3b",
      "slug": "ventasso",
      "name": "Ventasso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;